<template>
    <li>
        <div class="title"><span>価格軸</span></div>
        <div class="detail">
            <p><span>{{$store.state.detail.set.brand.price_zone.name}}</span></p>
        </div>
    </li>
</template>